var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShekelSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 152V328C256 341.25 266.75 352 280 352S304 341.25 304 328V152C304 85.828 250.156 32 184 32H40C26.75 32 16 42.75 16 56V456C16 469.25 26.75 480 40 480S64 469.25 64 456V80H184C223.688 80 256 112.297 256 152ZM408 32C394.75 32 384 42.75 384 56V360C384 399.764 351.764 432 312 432H192V184C192 170.75 181.25 160 168 160S144 170.75 144 184V456C144 469.254 154.746 480 168 480H312C378.273 480 432 426.273 432 360V56C432 42.75 421.25 32 408 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekelSign);
export default __webpack_public_path__ + "static/media/shekel-sign.7cf6e6ac7b3bff9fb14ec36775e24e25.svg";
export { ForwardRef as ReactComponent };